
















import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
// import { groupCompareSynthEZAvgScore } from '@/api/teachingProtection/assessment'
import BarSTD from '../../../_components/charts/BarSTD.vue'

  @Component({
    components: {
      BarSTD
    }
  })
export default class extends Vue {
    @Prop({ required: true }) private list: []

    // private frirstChartData: any = {}
    // private barDataArray: Array < object > = []

    // private mainArr = []
    // private subArr = []
    created() {
      // if (!this.$route.query.searchParams) return
      // let params = JSON.parse(this.$route.query.searchParams as string)
      // groupCompareSynthEZAvgScore(params).then(res => {
      //   // this.frirstChartData = res.data.synthEZAvgScore
      //   this.barDataArray = res.data.barChart || []
      //
      //   // this.mainArr = this.barDataArray.slice(0, 5)
      //   // this.subArr = this.barDataArray.slice(5, 8)
      // })
    }
}
